import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import DevicesTable from "./DevicesTable";
import InterventionsTable from "./InterventionsTable";
import UnlinkWindow from "./UnlinkWindow";
import BatteriesPage from "./Batteries";
import StatusOverlay from "../StatusOverlay";

const Devices = ({
  params,
  memberName,
  devices,
  interventions,
  listMemberDevices,
  doUnlinkMemberDevices,
  selectDeviceInterventions,
  resetSelectedDeviceInterventions,
  batteries,
  doFetchBatteryDevices,
  doFetchMoreBatteryDevices,
  unassignedBatteries,
  doFetchUnassignedDevices,
  doFetchMoreUnassignedDevices,
  doAssignDevices,
  doResetUnassignedDevices,
}) => {
  const memberID = params?.memberId;
  const [openUnlinkWindow, setOpenUnlinkWindow] = useState(false)
  const [vendor, setVendor] = useState("")

  useEffect(() => {
    // do; while here, fetch devices and for every minute after
    listMemberDevices({ memberID: memberID });

    const interval = setInterval(() => {
      listMemberDevices({ memberID: memberID });
    }, 1000 * 60);

    return () => clearInterval(interval);
  }, [memberID]);

  useEffect(() => {
    // clean up interventions on unmount
    return () => {
      resetSelectedDeviceInterventions();
    };
  }, []);

  return (
    <div>
      {process.env.REACT_APP_ENABLE_BATTERY === "true" && (
        <BatteriesPage
          params={params}
          memberName={memberName}
          devices={batteries.devices}
          total={batteries.total}
          isLoading={batteries.isLoading}
          isFetchingMore={batteries.isFetchingMore}
          hasNext={batteries.hasNext}
          doFetchBatteryDevices={doFetchBatteryDevices}
          doFetchMoreBatteryDevices={doFetchMoreBatteryDevices}
          unassignedBatteries={unassignedBatteries}
          doFetchUnassignedDevices={doFetchUnassignedDevices}
          doFetchMoreUnassignedDevices={doFetchMoreUnassignedDevices}
          doAssignDevices={doAssignDevices}
          doResetUnassignedDevices={doResetUnassignedDevices}
        />
      )}

      <h4>Thermostats</h4>
      <DevicesTable
        devices={devices}
        selectDeviceInterventions={selectDeviceInterventions}
        openUnlinkWindow={openUnlinkWindow}
        setOpenUnlinkWindow={setOpenUnlinkWindow}
        setVendor={setVendor}
      />
      {interventions && interventions?.length > 0 && (
        <InterventionsTable
          interventions={interventions}
          closeDialog={() => resetSelectedDeviceInterventions()}
        />
      )}
      {openUnlinkWindow && (
        <UnlinkWindow
          setOpenUnlinkWindow={setOpenUnlinkWindow}
          vendor={vendor}
          setVendor={setVendor}
          memberID={memberID}
          doUnlinkMemberDevices={doUnlinkMemberDevices}
        />
      )}

      <StatusOverlay />
    </div>
  );
};

Devices.propTypes = {
  params: PropTypes.shape({
    memberId: PropTypes.any,
  }),
  memberName: PropTypes.string,
  devices: PropTypes.array,
  listMemberDevices: PropTypes.func,
  selectDeviceInterventions: PropTypes.func,
  resetSelectedDeviceInterventions: PropTypes.func,
  batteries: PropTypes.object,
  doFetchBatteryDevices: PropTypes.func,
  doFetchMoreBatteryDevices: PropTypes.func,
  unassignedBatteries: PropTypes.object,
  doFetchUnassignedDevices: PropTypes.func,
  doFetchMoreUnassignedDevices: PropTypes.func,
  doAssignDevices: PropTypes.func,
  doResetUnassignedDevices: PropTypes.func,
};

export default Devices;
